import { render, staticRenderFns } from "./PDFListViewer.vue?vue&type=template&id=040edb26&scoped=true&"
import script from "./PDFListViewer.vue?vue&type=script&lang=ts&"
export * from "./PDFListViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PDFListViewer.vue?vue&type=style&index=0&id=040edb26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040edb26",
  null
  
)

export default component.exports